/**
 * Whether in-person premium visits are enabled.
 *
 * @returns {boolean} if the feature is enabled
 */
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';

export function useIsPremiumInPersonEnabled() {
  const { plus621InPersonSolvPlus32922: inPersonSolvPlus } = useLDFlags();
  return inPersonSolvPlus;
}
